import { render } from "./AddProduct.vue?vue&type=template&id=992db678&ts=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__